(function() {

    'use strict';

    angular.module('app').config(reportingsUrlConfig);

    reportingsUrlConfig.$inject = ['$routeProvider', '$locationProvider'];

    function reportingsUrlConfig($routeProvider, $locationProvider) {
        $routeProvider.
        when('/reporting/office-by-spend', {
            templateUrl: '/templates/pages/reporting/office-by-spend.html',
            controller: 'OfficeBySpendController',
            params: {
                parent: 'reporting',
                subParent: 'companyBySpend',
                htmlTitle: 'Reporting - Office By Spend',
                pageTitle: 'Reporting - Office By Spend'
            }
        }).
        when('/reporting/service-by-spend', {
            templateUrl: '/templates/pages/reporting/service-by-spend.html',
            controller: 'ServiceBySpendController',
            params: {
                parent: 'reporting',
                subParent: 'carrierBySpend',
                htmlTitle: 'Reporting - Service By Spend',
                pageTitle: 'Reporting - Service By Spend'
            }
        });

        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false
        });
    }

})();


// WEBPACK FOOTER //
// ./js/urls/reporting.js